// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"21":"a8d35139","133":"712cbb9c","156":"e2a4a9a0","383":"acaf8648","388":"81fbb3f0","437":"d3ec9df6","506":"e81297aa","539":"990eca11","569":"d773e9dd","648":"451c5cb8","668":"24caba20"}[chunkId] + ".chunk.js";
};